import { createFileRoute, redirect } from '@tanstack/react-router'

/** «Довідники» opens on people — the catalog that changes most often. */
export const Route = createFileRoute('/_app/references/')({
  beforeLoad: () => {
    throw redirect({ to: '/references/users/', replace: true })
  },
})
